import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewInSearchButton: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.view-in-search-button',
		defaultMessage: 'View in search',
		description: 'Button label view in search',
	},
});
